<ion-grid class="ion-no-padding">
  <div class="schoolInfoCont">
    <ion-row class="schoolLogoCont">
      <ion-col class="ion-no-padding">
        <div class="leftHrCont">
          <hr />
        </div>
        <app-school-logo [logo]="school.logoBase64"></app-school-logo>
        <div class="rightHrCont">
          <hr />
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="schoolHeaderCont">
      <ion-col>
        <h1 class="schoolHeader">{{ school.name }}</h1>
        <h2 class="schoolHeadteacher">Headteacher - {{ school.headteacher }}</h2>
      </ion-col>
    </ion-row>
  </div>

  @if (school.students?.length) {
    <ion-row class="studentList">
      <ion-col class="ion-no-padding">
        <app-student-item-list [school]="school" (selectStudent)="onShowStudent($event)"> </app-student-item-list>
      </ion-col>
    </ion-row>
  }

  @if (school.subscriptionState < 3 && school.features.length > 0) {
    <ion-row class="addMyChildrenCont">
      <ion-col class="ion-no-padding">
        <app-button-pill buttonText="Add my children" iconName="addMyChildrenIconWhite" (click)="onContinueOnboarding()">
        </app-button-pill>
      </ion-col>
    </ion-row>
  }

  <div class="panelCont">
    <ion-row class="schoolManagementCont channelsCont">
      <ion-col class="ion-no-padding">
        <ion-row>
          <ion-col class="ion-no-padding">
            <ion-row class="headerRow">
              <div class="schoolManagementHeader channelsHeader">Channels</div>
              <ion-button class="manageChannelsHeader" type="button" fill="clear" (click)="onEditChannels()">
                Manage Channels
              </ion-button>
            </ion-row>

            <ion-row class="lineRow">
              <hr class="headerLine" />
            </ion-row>
          </ion-col>
        </ion-row>

        <ion-col class="ion-no-padding">
          <app-round-image-clear-button
            buttonText="View school channel"
            icon="channelIcon"
            imageWidth="100%"
            imageHeight="100%"
            [chevron]="true"
          (click)="onShowChannel()"></app-round-image-clear-button>

          <!--<ion-col class="ion-no-padding">-->
          <!--<ph-round-image-clear-button buttonText="My Channels" icon="channelGreenIcon"></ph-round-image-clear-button>-->
        <!--</ion-col>-->

        <app-round-image-clear-button
          buttonText="Select a channel"
          icon="editChannelListIcon"
          [chevron]="true"
          [topSeparator]="true"
          (click)="onViewChannelList()">
        </app-round-image-clear-button>
      </ion-col>
    </ion-col>
  </ion-row>
</div>

@if (school.webLinks.length) {
  <ion-row class="schoolManagementCont quicklinksCont">
    <ion-col class="ion-no-padding">
      <ion-row class="schoolQuicklinksHeaderRow">
        <ion-col class="ion-no-padding">
          <ion-row class="headerRow quicklinksHeaderRow">
            <div class="schoolQuicklinksHeader quicklinksHeader">Quicklinks</div>
            <ion-button class="secondaryTextLink" type="button" fill="clear" (click)="onViewQuickLinkList()"
              >View All
            </ion-button>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="quicklinksRow">
        <div class="ionScroll">
          @for (weblink of school.webLinks; track trackByFn($index, weblink)) {
            <app-quicklink [quicklink]="weblink">
            </app-quicklink>
          }
        </div>
      </ion-row>
    </ion-col>
  </ion-row>
}

<div class="panelCont">
  @if (school.subscriptionState >= 3) {
    <ion-row class="schoolManagementCont detailsCont">
      <ion-col class="ion-no-padding">
        <ion-row>
          <ion-col class="ion-no-padding">
            <ion-row class="headerRow">
              <div class="schoolManagementHeader detailsHeader">My Contact Details</div>
            </ion-row>
            <ion-row class="lineRow">
              <hr class="headerLine" />
            </ion-row>
          </ion-col>
        </ion-row>
        <ion-col class="ion-no-padding">
          <app-round-image-clear-button
            buttonText="View my contact details"
            icon="updateContactInfoIcon"
            [chevron]="true"
          (click)="onUpdateContactDetails()"></app-round-image-clear-button>
        </ion-col>
      </ion-col>
    </ion-row>
  }
</div>

<div class="panelCont">
  <ion-row class="schoolManagementCont contactDetailsCont">
    <ion-col class="ion-no-padding">
      <ion-row>
        <ion-col class="ion-no-padding">
          <ion-row class="headerRow">
            <div class="schoolManagementHeader contactDetailsHeader">School Contact Details</div>
          </ion-row>

          <ion-row class="lineRow">
            <hr class="headerLine" />
          </ion-row>
        </ion-col>
      </ion-row>

      <ion-col class="ion-no-padding">
        @if (school.websiteUrl !== null) {
          <app-round-image-clear-button
            buttonText="Visit school website"
            [href]="school.websiteUrl"
            icon="newWebsiteIcon"
            [chevron]="true">
          </app-round-image-clear-button>
        }

        <app-round-image-clear-button
          buttonText="View school contact details"
          icon="contactIcon"
          [topSeparator]="school.websiteUrl !== null"
          [chevron]="true"
          (click)="onShowContactInfo()">
        </app-round-image-clear-button>
      </ion-col>
    </ion-col>
  </ion-row>
</div>
</ion-grid>
